export default __webpack_public_path__ + "static/joyful-85760c736113677a7643092f266a4a0c.png";